import { render, staticRenderFns } from "./TicketAddForm.vue?vue&type=template&id=2753874c&scoped=true&"
import script from "./TicketAddForm.vue?vue&type=script&lang=js&"
export * from "./TicketAddForm.vue?vue&type=script&lang=js&"
import style0 from "./TicketAddForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TicketAddForm.vue?vue&type=style&index=1&id=2753874c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2753874c",
  null
  
)

export default component.exports